'use client';

import {createContext, useContext} from 'react';

interface IAccordionGroupContext {
    onSelect: (key: string | number | null) => void;
    current: string | number | null;
    shouldGroupUnmountOnExit: boolean;
}

export const AccordionGroupContext =
    createContext<null | IAccordionGroupContext>(null);

export const useAccordionGroup = () => {
    const context = useContext(AccordionGroupContext);
    if (!context) {
        throw Error('Missing AccordionContext');
    }
    return context;
};
